import {call, put, takeLatest} from "redux-saga/effects";
import {checkPermission} from "../../../utils/Authorization/authorization";
import {API} from "../../../api/api";
import {hallsAPI} from "../api/api";
import {HallsActionTypes} from "../actions/actionTypes";
import {removeAccents} from "../../../utils/utils";
import {ToasterService} from "../../../services/toaster/toaster.service";

function* getServerLicenseState(action) {
    try {
        const state = yield call(() =>
            hallsAPI.getServerLicenseState({
                serverId: action.payload.serverId
            })
        );
        yield put({
            type: HallsActionTypes.GET_SERVER_LICENSE_STATE_SUCCESS,
            payload: {
                state:
                    state.data.results.length > 0
                        ? state.data.results[0].server_state_id
                        : 1
            }
        });
    } catch (e) {
        yield put({
            type: HallsActionTypes.GET_SERVER_LICENSE_STATE_FAIL,
            message: e.message
        });
    }
}

export function* getServerLicenseStateWatcher() {
    yield takeLatest(
        HallsActionTypes.GET_SERVER_LICENSE_STATE,
        getServerLicenseState
    );
}

function* initLicenseProcess(action) {
    try {
        const license = yield call(() =>
            hallsAPI.initLicense({
                serverId: action.payload.serverId,
                file: action.payload.file
            })
        );

        yield put({
            type: HallsActionTypes.UPLOAD_LICENSE_SEED_SUCCESS,
            payload: {
                state: license.data.server_state_id
            }
        });

        yield put({
            type: HallsActionTypes.GET_LICENSE_ACTIVITY,
            payload: {
                page: 0,
                top: 12,
                serverId: action.payload.serverId
            }
        });

        ToasterService.successToast("Seed Successfully uploaded.");
    } catch (e) {
        API.handleError(e.response, "Error uploading Seed.");

        yield put({
            type: HallsActionTypes.UPLOAD_LICENSE_SEED_FAIL,
            message: e.message
        });
    }
}

export function* initLicenseProcessWatcher() {
    yield takeLatest(HallsActionTypes.UPLOAD_LICENSE_SEED, initLicenseProcess);
}

function* rejectLicenseId(action) {
    try {
        const license = yield call(() =>
            hallsAPI.rejectLicenseId({
                serverId: action.payload.serverId
            })
        );

        yield put({
            type: HallsActionTypes.REJECT_LICENSE_ID_SUCCESS,
            payload: {
                state: license.data.server_state_id
            }
        });

        yield put({
            type: HallsActionTypes.GET_LICENSE_ACTIVITY,
            payload: {
                page: 0,
                top: 12,
                serverId: action.payload.serverId
            }
        });

        ToasterService.successToast("License Id successfully rejected.");
    } catch (e) {
        API.handleError(e.response, "Error rejecting license Id.");

        yield put({
            type: HallsActionTypes.REJECT_LICENSE_ID_FAIL,
            message: e.message
        });
    }
}

export function* rejectLicenseIdWatcher() {
    yield takeLatest(HallsActionTypes.REJECT_LICENSE_ID, rejectLicenseId);
}

function* confirmLicenseId(action) {
    try {
        const license = yield call(() =>
            hallsAPI.confirmLicenseId({
                serverId: action.payload.serverId
            })
        );

        yield put({
            type: HallsActionTypes.CONFIRM_LICENSE_ID_SUCCESS,
            payload: {
                state: license.data.server_state_id
            }
        });

        yield put({
            type: HallsActionTypes.GET_LICENSE_ACTIVITY,
            payload: {
                page: 0,
                top: 12,
                serverId: action.payload.serverId
            }
        });

        ToasterService.successToast("License Id successfully confirmed.");
    } catch (e) {
        API.handleError(e.response, "Error confirming license Id.");

        yield put({
            type: HallsActionTypes.CONFIRM_LICENSE_ID_FAIL,
            message: e.message
        });
    }
}

export function* confirmLicenseIdWatcher() {
    yield takeLatest(HallsActionTypes.CONFIRM_LICENSE_ID, confirmLicenseId);
}

function* updateLicenseDuration(action) {
    try {
        const license = yield call(() =>
            hallsAPI.updateLicenseDuration({
                serverId: action.payload.serverId,
                duration: action.payload.duration
            })
        );

        yield put({
            type: HallsActionTypes.UPDATE_LICENSE_DURATION_SUCCESS,
            payload: license.data
        });

        yield put({
            type: HallsActionTypes.GET_LICENSE_ACTIVITY,
            payload: {
                page: 0,
                top: 12,
                serverId: action.payload.serverId
            }
        });

        ToasterService.successToast("License duration successfully updated.");
    } catch (e) {
        API.handleError(e.response, "Error setting license duration.");

        yield put({
            type: HallsActionTypes.UPDATE_LICENSE_DURATION_FAIL,
            message: e.message
        });
    }
}

export function* updateLicenseDurationWatcher() {
    yield takeLatest(
        HallsActionTypes.UPDATE_LICENSE_DURATION,
        updateLicenseDuration
    );
}

function* cancelLicenseProcess(action) {
    try {
        const license = yield call(() =>
            hallsAPI.cancelLicenseProcess({
                serverId: action.payload.serverId
            })
        );

        yield put({
            type: HallsActionTypes.CANCEL_LICENSE_PROCESS_SUCCESS,
            payload: {
                state: license.data.server_state_id
            }
        });

        yield put({
            type: HallsActionTypes.GET_LICENSE_ACTIVITY,
            payload: {
                page: 0,
                top: 12,
                serverId: action.payload.serverId
            }
        });

        ToasterService.successToast("License process canceled with success.");
    } catch (e) {
        API.handleError(e.response, "Error canceling process.");

        yield put({
            type: HallsActionTypes.CANCEL_LICENSE_PROCESS_FAIL,
            message: e.message
        });
    }
}

export function* cancelLicenseProcessWatcher() {
    yield takeLatest(
        HallsActionTypes.CANCEL_LICENSE_PROCESS,
        cancelLicenseProcess
    );
}

function* getLicenseDownload(action) {
    try {
        const request = yield call(() =>
            hallsAPI.getLicenseDownload({
                serverId: action.payload.serverId
            })
        );

        const downloadLink = document.createElement("a");
        const base64 = request.data;
        const byteCharacters = base64; //atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {
            type: "application/octet-stream"
        });
        const url = window.URL.createObjectURL(blob);
        downloadLink.href = url;
        downloadLink.setAttribute(
            "download",
            `server-${removeAccents(
                action.payload.serverName
                    .replace(/ /g, "_")
                    .replace(/[^\w\s]/gi, "")
            )}-${Date.now()}.lic`
        );
        document.body.appendChild(downloadLink);
        downloadLink.click();

        yield put({
            type: HallsActionTypes.GET_LICENSE_DOWNLOAD_SUCCESS,
            payload: request.data
        });
        if (checkPermission("licensing_history")){
            yield put({
                type: HallsActionTypes.GET_LICENSE_ACTIVITY,
                payload: {
                    page: 0,
                    top: 12,
                    serverId: action.payload.serverId
                }
            });
        }

    } catch (e) {
        API.handleError(e.response, "Error downloading license.");

        yield put({
            type: HallsActionTypes.GET_LICENSE_DOWNLOAD_FAIL,
            message: e.message
        });
    }
}

export function* getLicenseDownloadWatcher() {
    yield takeLatest(HallsActionTypes.GET_LICENSE_DOWNLOAD, getLicenseDownload);
}

function* setLicenseApplied(action) {
    try {
        const license = yield call(() =>
            hallsAPI.setLicenseApplied({
                serverId: action.payload.serverId
            })
        );

        yield put({
            type: HallsActionTypes.GET_SERVER,
            payload: {
                serverId: action.payload.serverId
            }
        })

        yield put({
            type: HallsActionTypes.GET_SERVER_LICENSE,
            payload: {
                serverId: action.payload.serverId
            }
        })

        yield put({
            type: HallsActionTypes.SET_LICENSE_APPLIED_SUCCESS,
            payload: {
                state: license.data.server_state_id
            }
        });

        yield put({
            type: HallsActionTypes.GET_LICENSE_ACTIVITY,
            payload: {
                page: 0,
                top: 12,
                serverId: action.payload.serverId
            }
        });

        ToasterService.successToast("License successfully applied.");
    } catch (e) {
        API.handleError(e.response, "Error marking license as applied.");

        yield put({
            type: HallsActionTypes.SET_LICENSE_APPLIED_FAIL,
            message: e.message
        });
    }
}

export function* setLicenseAppliedWatcher() {
    yield takeLatest(HallsActionTypes.SET_LICENSE_APPLIED, setLicenseApplied);
}

function* renewLicense(action) {
    try {
        const license = yield call(() =>
            hallsAPI.renewLicense({serverId: action.payload.serverId})
        );

        yield put({
            type: HallsActionTypes.RENEW_LICENSE_SUCCESS,
            payload: {
                state: license.data.server_state_id
            }
        });

        yield put({
            type: HallsActionTypes.GET_LICENSE_ACTIVITY,
            payload: {
                page: 0,
                top: 12,
                serverId: action.payload.serverId
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error renewing license.");

        yield put({
            type: HallsActionTypes.RENEW_LICENSE_FAIL,
            message: e.message
        });
    }
}

export function* renewLicenseWatcher() {
    yield takeLatest(HallsActionTypes.RENEW_LICENSE, renewLicense);
}

function* updateRemotelyLicense(action) {
    try {
        const license = yield call(() =>
            hallsAPI.updateRemotelyLicense({serverId: action.payload.serverId})
        );

        yield put({
            type: HallsActionTypes.GET_SERVER,
            payload: {
                serverId: action.payload.serverId
            }
        })

        yield put({
            type: HallsActionTypes.GET_SERVER_LICENSE,
            payload: {
                serverId: action.payload.serverId
            }
        })

        yield put({
            type: HallsActionTypes.GET_LICENSE_ACTIVITY,
            payload: {
                page: 0,
                top: 12,
                serverId: action.payload.serverId
            }
        });

        yield put({
            type: HallsActionTypes.UPDATE_REMOTELY_LICENSE_SUCCESS,
            payload: {
                state: license.data.server_state_id
            }
        });

        ToasterService.successToast("The license was successfully updated remotely.");
    } catch (e) {
        API.handleError(e.response, "Error remotely updating license.");

        yield put({
            type: HallsActionTypes.UPDATE_REMOTELY_LICENSE_FAIL,
            message: e.message
        });
    }
}

export function* updateRemotelyLicenseWatcher() {
    yield takeLatest(HallsActionTypes.UPDATE_REMOTELY_LICENSE, updateRemotelyLicense);
}

function* invalidateLicense(action) {
    try {
        const license = yield call(() =>
            hallsAPI.invalidateLicense({serverId: action.payload.serverId})
        );

        yield put({
            type: HallsActionTypes.GET_LICENSE_ACTIVITY,
            payload: {
                page: 0,
                top: 12,
                serverId: action.payload.serverId
            }
        });

        yield put({
            type: HallsActionTypes.INVALIDATE_LICENSE_SUCCESS,
            payload: {
                state: license.data.server_state_id
            }
        });


        ToasterService.successToast("License invalidated successfully.");

    } catch (e) {
        API.handleError(e.response, "Error invalidating license.");

        yield put({
            type: HallsActionTypes.INVALIDATE_LICENSE_FAIL,
            message: e.message
        });
    }
}

export function* invalidateLicenseWatcher() {
    yield takeLatest(HallsActionTypes.INVALIDATE_LICENSE, invalidateLicense);
}
